angular.module('CaresApp').component('ocrPersonaEdit', {
  templateUrl: 'components/ocr-persona-edit/ocr-persona-edit.template.html',
  controller: [
    '$scope',
    '$document',
    '$location',
    '$routeParams',
    '$mdToast',
    '$mdDialog',
    'PersonaService',
    'OcrLookups',
    'PersonaBillingRateService',
    'OcrUtils',
    'OcrAuth',
    function($scope, $document, $location, $routeParams, $mdToast, $mdDialog,
      PersonaService, OcrLookups, PersonaBillingRateService, OcrUtils, OcrAuth) {
      $scope.$emit("SetSearchBox", false);
      const self = this;
      self.applicableToOptions = self.permissions = OcrLookups.dummyList;
      self.hasPermission = OcrAuth.checkPermission;

      self.personaPermissions = [];
      self.selection = [];
      self.billingRates = [];

      OcrLookups.get('Permission').then(
        (permissions) => self.permissions = permissions,
      );

      const getApplicableToPromise = OcrLookups.get('PersonaApplicableTo').then(
        (applicableTo) => self.applicableToOptions = applicableTo,
      );

      self.today = new Date();

      if ($routeParams.personaId !== 'create') {
        self.id = $routeParams.personaId;
      } else {
        OcrUtils.setPageTitle('New Persona');
      }
      self.loading = true;
      if (self.id) {
        if (angular.isString(self.id)) {
          self.id = parseInt(self.id);
        }
        self.promise = PersonaService.get({
          id: self.id,
        }).$promise
          .then(function(resp) {
            self.entity = resp;
            OcrUtils.setPageTitle(`Persona: ${self.entity.name}`);
          })
          .finally(() => self.loading = false);

        OcrLookups.get('PersonaPermission').then(function(
          personaPermissions) {
          self.personaPermissions = personaPermissions;
          for (const personaPermission of personaPermissions) {
            if (personaPermission.personaId === self.id
              && !self.selection.includes(personaPermission.permissionId)
            ) {
              self.selection.push(personaPermission.permissionId);
            }
          }
        }).catch(function() {
          console.error("Unable to retrieve persona permissions.");
          self.personaPermissions = [];
        });

        PersonaBillingRateService.get({
          persona_id: self.id,
        }).$promise
          .then(function(response) {
            self.billingRates = response.list;
          })
          .catch(function(error) {
            console.error("Unable to get persona billing rates: %O", error);
            self.billingRates = [];
          });
      } else {
        self.entity = {
          startDate: self.today,
        };
        getApplicableToPromise.then(() => {
          const option = self.applicableToOptions.lookup('Users', 'applicableTo');
          self.entity.applicableToId = option.id;
        }).finally(() => self.loading = false);
      }

      self.toggleSelection = function toggleSelection(permissionId) {
        const idx = self.selection.indexOf(permissionId);

        if (idx >= 0) {
          self.selection.splice(idx, 1);
        } else {
          self.selection.push(permissionId);
        }
      };

      self.updateRate = function() {
        if (self.entity.rateValue === null) {
          self.entity.billingRateCents = null;
        } else {
          self.entity.billingRateCents = parseInt(self.entity.rateValue.replace(
            /\D/g, ""));
        }
      };


      self.showUserRelatedFields = function() {
        if (angular.isUndefined(self.entity)) {
          return false;
        }
        const option = self.applicableToOptions.lookup(self.entity.applicableToId);
        return option && option.applicableTo.includes('Users');
      }

      self.addBillingRate =
        () => $mdDialog.show({
          controller: 'AddPersonaBillingRateDialogController',
          templateUrl: 'tmpl/add-persona-billing-rate-dialog.html',
          parent: angular.element($document[0].body),
          locals: {
            persona: self.entity,
            billingRates: self.billingRates,
          },
          clickOutsideToClose: false,
          fullscreen: self.customFullscreen, // Only for -xs, -sm breakpoints.
        });

      self.save = function(andExit) {
        OcrLookups.remove('Persona');
        OcrLookups.remove('Persona', true);
        OcrLookups.remove('PersonaPermission');
        OcrLookups.remove('PersonaPermission', true);
        $mdToast.show(
          $mdToast.simple()
            .textContent('Saving...')
            .position("bottom right"),
        );
        let saveFunction = null;
        let saveArgs = null;
        self.entity.permissionIds = self.selection;
        if (self.id) {
          saveFunction = PersonaService.update;
          saveArgs = [
            {
              id: self.id,
            },
            self.entity,
          ];
        } else {
          saveFunction = PersonaService.save;
          saveArgs = [self.entity];
        }
        saveFunction.apply(this, saveArgs).$promise.then(
          function() {
            self.form.$setPristine();
            $mdToast.show(
              $mdToast.simple()
                .textContent('Persona saved.')
                .position("bottom right"),
            );
            if (andExit) {
              self.close(true);
            }
          },
        ).catch(function(error) {
          if (error && error.data && error.data.status === 401) {
            self.close(true);
            return;
          }
          if (error && error.data) {
            $mdToast.show(
              $mdToast.simple()
                .textContent(error.data.reason)
                .position("bottom right"),
            );
          }
        });
      };

      self.close = function(noConfirm) {
        if (noConfirm || self.form.$pristine) {
          $location.path(`/views/${$routeParams.view}`);
        } else {
          const message
            = "Are you sure that you want to close this form without saving your changes?";
          $mdDialog.show(
            $mdDialog.confirm()
              .parent(angular.element($document[0].querySelector(
                '#popupContainer')))
              .clickOutsideToClose(false)
              .title('Confirm Form Close')
              .textContent(message)
              .ariaLabel(message)
              .ok('Close Form')
              .cancel('Cancel'),
          ).then(
            () => $location.path(`/views/${$routeParams.view}`),
            () => {},
          );
        }
      };

      self.deleteForm = function() {
        const message
          = "Are you sure that you want to delete this persona?";

        $mdDialog.show(
          $mdDialog.confirm()
            .parent(angular.element($document[0].querySelector(
              '#popupContainer')))
            .clickOutsideToClose(false)
            .title('Confirm Persona Delete')
            .textContent(message)
            .ariaLabel(message)
            .ok('Delete Persona')
            .cancel('Cancel'),
        ).then(function() {
          // ok
          OcrLookups.remove('Persona');
          OcrLookups.remove('Persona', true);
          $mdToast.show(
            $mdToast.simple()
              .textContent('Deleting...')
              .position("bottom right"),
          );

          PersonaService.delete({
            id: self.id,
          }, self.entity).$promise.then(function() {
            $mdToast.show(
              $mdToast.simple()
                .textContent('Persona deleted.')
                .position("bottom right"),
            );
            $location.path(`/views/${$routeParams.view}`);
          })
            .catch(function(error) {
              if (error && error.data) {
                $mdToast.show(
                  $mdToast.simple()
                    .textContent(error.data.reason)
                    .position("bottom right"),
                );
              }
            });
        }, () => {});
      };

      $scope.$on('$locationChangeStart',
        function(event, newUrl, oldUrl) {
          const removeQueryParams = (url) => {
            if (url) {
              const index = url.indexOf("?");
              if (index >= 0) {
                return url.substring(0, index);
              }
            }
            return url;
          };

          const newPath = $location.path();

          if (
            newPath === "/"
            || self.form.$pristine
            || removeQueryParams(newUrl) === removeQueryParams(oldUrl)
          ) {
            return;
          }

          event.preventDefault();

          const message
            = "Are you sure that you want to close this form without saving your changes?";

          $mdDialog.show(
            $mdDialog.confirm()
              .parent(angular.element($document[0].querySelector(
                '#popupContainer')))
              .clickOutsideToClose(false)
              .title('Confirm Page Exit')
              .textContent(message)
              .ariaLabel(message)
              .ok('OK')
              .cancel('Cancel'),
          ).then(() => {
            self.form.$setPristine();
            $location.path(newPath);
          });
        });

      self.$onInit =
        () => $scope.$watch(
          () => angular.isDefined(self.form),
          function() {
            if (self.form && self.form.$invalid) {
              angular.forEach(self.form.$error, function(field) {
                angular.forEach(field, function(errorField) {
                  errorField.$setTouched();
                });
              });
            }
          }, true);
    },
  ],
});
